var _require = require('../shared-constants'),
  VALID = _require.VALID,
  INVALID = _require.INVALID,
  CAN_NOT_BE_SANITIZED = _require.CAN_NOT_BE_SANITIZED;
var MALE_NATIONAL_ID = 'male';
var FEMALE_NATIONAL_ID = 'female';
module.exports = {
  MALE_NATIONAL_ID: MALE_NATIONAL_ID,
  FEMALE_NATIONAL_ID: FEMALE_NATIONAL_ID,
  VALID: VALID,
  INVALID: INVALID,
  CAN_NOT_BE_SANITIZED: CAN_NOT_BE_SANITIZED
};